module.exports = __webpack_public_path__ + "static/media/bf10.19399c4a.png";